<template>
  <div id="app">
    <Pausenplan/>
    <div v-if="isReleaseCandidate" class="release-candidate-badge" title="Release Candidate" aria-label="Release Candidate">
      <span class="release-candidate-dot" aria-hidden="true"></span>RC
    </div>
  </div>
</template>

<script>
import Pausenplan from './components/Pausenplan.vue'

export default {
  name: 'App',
  data() {
    return {
      isReleaseCandidate: process.env.VUE_APP_RELEASE_CHANNEL === 'rc'
    }
  },
  components: {
    Pausenplan
  }
}
</script>

<style>

*{
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}
html, body{
    padding: 0 !important;
    margin: 0 !important;
    box-sizing: border-box !important;
    overflow: hidden;
}
#app {
    min-height: 100vh;
    background-color: #fff;
}
.release-candidate-badge {
    position: fixed;
    top: 8px;
    left: 8px;
    z-index: 10000000;
    display: flex;
    align-items: center;
    padding: 5px 9px;
    border-radius: 4px;
    background-color: #282828;
    color: #fff;
    font: bold 16px/20px Arial, sans-serif;
    pointer-events: none;
}
.release-candidate-dot {
    width: 12px;
    height: 12px;
    margin-right: 6px;
    border-radius: 50%;
    background-color: #f59a23;
}
</style>
